export const RegionMockup = () => (
    <div className="bg-white rounded-xl shadow-xl w-[300px] p-6">
        {/* Settings card header */}
        <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 rounded-lg bg-[#8db599]/20 flex items-center justify-center">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M10 12.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z" stroke="#8db599" strokeWidth="1.5" />
                    <path d="M16.167 10c0 .442-.05.873-.146 1.287l1.563 1.224a.375.375 0 01.085.476l-1.48 2.563a.375.375 0 01-.455.163l-1.842-.742a6.146 6.146 0 01-1.115.646l-.28 1.958a.375.375 0 01-.37.325h-2.96a.375.375 0 01-.37-.325l-.28-1.958a6.145 6.145 0 01-1.115-.646l-1.843.742a.375.375 0 01-.455-.163l-1.48-2.563a.375.375 0 01.085-.476l1.563-1.224A6.303 6.303 0 013.833 10c0-.442.05-.873.146-1.287L2.416 7.49a.375.375 0 01-.085-.476l1.48-2.563a.375.375 0 01.455-.163l1.843.742c.344-.257.717-.476 1.115-.646l.28-1.958a.375.375 0 01.37-.325h2.96c.185 0 .342.136.37.325l.28 1.958c.398.17.771.389 1.115.646l1.842-.742a.375.375 0 01.455.163l1.48 2.563a.375.375 0 01-.085.476l-1.563 1.224c.096.414.146.845.146 1.287z" stroke="#8db599" strokeWidth="1.5" />
                </svg>
            </div>
            <div>
                <div className="h-3 w-28 bg-gray-300 rounded mb-1.5" />
                <div className="h-2 w-20 bg-gray-200 rounded" />
            </div>
        </div>
        {/* Settings rows */}
        <div className="space-y-4">
            {/* VAT setting */}
            <div className="flex items-center justify-between py-2 border-b border-gray-100">
                <div className="h-3 w-16 bg-gray-200 rounded" />
                <div className="flex items-center gap-2">
                    <span className="text-sm font-medium text-[#8db599]">8.1%</span>
                </div>
            </div>
            {/* Currency setting */}
            <div className="flex items-center justify-between py-2 border-b border-gray-100">
                <div className="h-3 w-14 bg-gray-200 rounded" />
                <div className="px-3 py-1 bg-gray-100 rounded text-sm font-medium text-gray-600">CHF</div>
            </div>
            {/* Rounding setting */}
            <div className="flex items-center justify-between py-2 border-b border-gray-100">
                <div className="h-3 w-20 bg-gray-200 rounded" />
                <div className="h-3 w-24 bg-gray-100 rounded" />
            </div>
            {/* Toggle setting */}
            <div className="flex items-center justify-between py-2">
                <div className="h-3 w-28 bg-gray-200 rounded" />
                <div className="w-10 h-5 bg-[#8db599] rounded-full relative">
                    <div className="absolute right-0.5 top-0.5 w-4 h-4 bg-white rounded-full shadow" />
                </div>
            </div>
        </div>
    </div>
);